let cfg = {
  // SKIP_CACHE: true,
  VERSION: '1.0.1',
};

export default cfg;
